import type { ArrowColor, FrameBorderColor, FrameColor } from "@bedrock/domain";

export const ARROW_COLORS = [
  { value: "ink", label: "Ink" },
  { value: "blue", label: "Blue" },
  { value: "green", label: "Green" },
  { value: "orange", label: "Orange" },
  { value: "red", label: "Red" },
  { value: "violet", label: "Violet" }
] as const satisfies ReadonlyArray<{ value: ArrowColor; label: string }>;

export const FRAME_COLORS = [
  { value: "clear", label: "Clear" },
  { value: "blue", label: "Blue" },
  { value: "green", label: "Green" },
  { value: "yellow", label: "Yellow" },
  { value: "lilac", label: "Lilac" },
  { value: "clay", label: "Clay" }
] as const satisfies ReadonlyArray<{ value: FrameColor; label: string }>;

export const FRAME_BORDER_COLORS = [
  { value: "match", label: "Match" },
  { value: "ink", label: "Ink" },
  { value: "blue", label: "Blue" },
  { value: "green", label: "Green" },
  { value: "yellow", label: "Yellow" },
  { value: "lilac", label: "Lilac" },
  { value: "clay", label: "Clay" }
] as const satisfies ReadonlyArray<{ value: FrameBorderColor; label: string }>;

export function arrowColorLabel(color: ArrowColor): string {
  return ARROW_COLORS.find((option) => option.value === color)?.label ?? "Ink";
}

export function frameColorLabel(color: FrameColor): string {
  return FRAME_COLORS.find((option) => option.value === color)?.label ?? "Clear";
}

export function frameBorderColorLabel(color: FrameBorderColor): string {
  return FRAME_BORDER_COLORS.find((option) => option.value === color)?.label ?? "Match";
}
